<sc-padding [fitHeight]="true">
  <sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true">
    <div>
      <sc-items-grid [width]="120" [gap]="16">
        <ac-resource-image-thumbnail *ngFor="let resource of transportOption?.resources" (click)="selectResource(resource)" [resourceId]="resource">{{resource}}</ac-resource-image-thumbnail>
      </sc-items-grid>
    </div>
    <sc-content-spacer [vertical]="true"></sc-content-spacer>
    <sc-flex-fitting-content [vertical]="true">
      <ac-resource-image-view withControls [resourceId]="currentResourceId" (deleteClicked)="handleDeleteClicked()"></ac-resource-image-view>
    </sc-flex-fitting-content>
    <sc-content-spacer [vertical]="true"></sc-content-spacer>
    <div>
      <sc-flex [centered]="true">
        <ac-resource-upload (uploaded)="handleUpadedResource($event)" usage="transport_option"></ac-resource-upload>
      </sc-flex>
    </div>
  </sc-flex>
</sc-padding>
